module.exports = __webpack_public_path__ + "static/icon-line-badge-490cc8cb7d42ef0ba9dab26fbfb49952.png";